const React = require("react");
const T = React.PropTypes;
const moment = require("moment");

require("./Section.less");

const navigator = require("~/navigator.js");
const config = require("~/config.js");
const QuestionsDiffer = require("~/types/Section.js").QuestionsDiffer;

const SectionType = require("~/types/Section.js").PropType;
const QuestionType = require("~/types/Question.js").PropType;
const QuestionChangeDispatchers = require("~/events/questionChange/questionChangeDispatchers.js");
const SectionDispatchers = require("~/events/section/sectionDispatchers.js");

const ContentBlock = require("../ContentBlock/ContentBlock.jsx");
const SectionFooter = require("../SectionFooter/SectionFooter.jsx");
const Question = require("../Question/Question.jsx");
const MajorMessage = require("../MajorMessage/MajorMessage.jsx");
const MajorError = require("../MajorError/MajorError.jsx");
const BoxLocker = require("../BoxLocker/BoxLocker.jsx");
const CubeIcon = require("../CubeIcon/CubeIcon.jsx");
const TextStateTicker = require("../TextStateTicker/TextStateTicker.jsx");

function questionsByDisplayOrder(q1, q2) {
    if (q1.DisplayOrder > q2.DisplayOrder) return 1;
    
    if (q1.DisplayOrder < q2.DisplayOrder) return -1;

    if (q1.GUID > q2.GUID) return 1;

    return -1;
}

const Section = React.createClass({
    propTypes: {
        Section: SectionType.isRequired,
        QuestionSnapshot: T.arrayOf(QuestionType).isRequired,
        PageIDPath: T.arrayOf(T.string).isRequired,
        IsReadOnly: T.bool.isRequired,
        NextSectionID: T.string,
        PreviousSectionID: T.string
    },
    getInitialState() {
        return {
            LastSavedAt: null,
            popupdismissed: false
        };
    },
    componentWillMount() {
        window.addEventListener("beforeunload", this.CheckWindowClose);
    },
    componentWillUnmount() {
        window.removeEventListener("beforeunload", this.CheckWindowClose);
    },
    componentWillReceiveProps(next) {
        // If we're transitioning from "saving" to "saved," refresh
        // our original questions.
        if (this.props.Section.IsSaving
            && !next.Section.IsSaving
            && !next.Section.SaveError) {
            this.setState({
                LastSaved: moment().format("h:mm")
            });
        }
    },
    displayPopup(questions) {

        let i = 0;
        for (i = 0; i < questions.length; i++)
        {
            if (questions[i].DisplayHTML.includes("Count cash on-hand")) {
                if (questions[i].AnswerSelections[0].SelectionText === "")
                    return true;
            }
        }

        return false; 
    },
    GotItClicked() {
        this.setState({popupdismissed: true}); 
    }, 
    render() {
        const contentBlocks = this.props.Section.Questions
            .sort(questionsByDisplayOrder)
            .map(this.MakeContentBlock);

        if (this.props.Section.SaveError) {
            const errorMessage = this.GetErrorMessage();

            return errorMessage;
        }

        const hasNoInvalid = this.HasNoInvalids();

        const canSave = !this.props.Section.IsSaving;

        const showpopup = this.displayPopup(this.props.Section.Questions); 

        const message =
            hasNoInvalid
            ? this.GetValidMessage()
            : (<strong className="cs-Section__invalid">
                One or more questions requires&nbsp;an&nbsp;answer.
            </strong>);

        return (<section className="cs-Section">
            {this.props.Section.IsSaving && (<BoxLocker>
                <div className="cs-Section__saving-text">
                    <CubeIcon Color="#c00"
                              style={{ top: ".3em", left: "-.5em" }} />
                    Saving
                    <TextStateTicker TextVals={[".", "..", "...", "...", "..." ]}
                                     TickIntervalMS={250}
                                     style={{width: "2em" }} />
                </div>
            </BoxLocker>)}
            {(showpopup && !this.state.popupdismissed) && (<BoxLocker>
                <div className="cs-Section__popup-text">
                    <CubeIcon Color="#c00"
                              style={{ top: ".3em", marginRight: "0px"}} />
                    <b style={{marginRight: "300px"}}>Notice</b>
                    <button onClick={this.GotItClicked} className="btn btn-success" style={{width: "150px"}}>Got it!</button>
                    <hr />
                    <p className="cs-Section__popup-message">
                        Before you get started, please immediately count the cash on-hand (petty cash, bank, and truck rental funds).
                        Enter the total verified amount and note the reason for any discrepancies in the Cash Control section of the audit.<br/>
                        The walkthrough date must match the Store Operations audit submission date.
                    </p>
                </div>
            </BoxLocker>)}
            <ol className="cs-Section__list">
                {contentBlocks}
            </ol>
            <SectionFooter IsFirstSection={this.props.PreviousSectionID === null}
                           IsLastSection={this.props.NextSectionID === config.ConfirmationPage}
                           OnPrevious={this.ToPreviousSection}
                           OnNext={this.ToNextSection}
                           OnComplete={this.CompleteAudit}
                           OnSave={this.Save}
                           CanSave={canSave}
                           Message={message} />
        </section>);
    },
    MakeContentBlock(q, i) {
        const handler = this.GetQuestionChangeHandler(q);
        const sectionIDPath = this.props.PageIDPath.concat(this.props.Section.GUID);
        let isReadOnly = this.props.IsReadOnly;
        if (q.Task === undefined || q.Task === null) q.Task = "";

        if (this.props.Section.Questions[0].AnswerSelections.length > 0
            && (this.props.Section.Questions[0].AnswerSelections[0].SelectionText == 'No' || this.props.Section.Questions[0].AnswerSelections[0].SelectionText == 'N/A')
            && this.props.Section.Questions[0].DisplayHTML.includes('If not, the remaining questions in this section will be skipped')
            && this.props.Section.Questions[0].GUID != q.GUID
            ) {
            isReadOnly = true;
            let selections = q.AnswerSelections;
            selections[0].SelectionText = 'N/A';
            q.AnswerSelections = selections;
        } else {
            isReadOnly = this.props.IsReadOnly;
        }

        if (i === 0) {
            return (<ContentBlock key={q.GUID}>
                <h3 className="cs-Section__title"
                    dangerouslySetInnerHTML={{ __html: this.props.Section.TitleHTML }}></h3>
                <Question Question={q}
                    IsReadOnly={isReadOnly}
                    OnAnswerChange={handler}
                    SectionIDPath={sectionIDPath} />
            </ContentBlock>);
        }

        return (<ContentBlock key={q.GUID}>
            <Question Question={q}
                IsReadOnly={isReadOnly}
                OnAnswerChange={handler}
                SectionIDPath={sectionIDPath} />
        </ContentBlock>);
    },
    GetValidMessage() {
        if (this.state.LastSavedAt) {
            return `Last saved at ${moment(this.state.LastSavedAt).format("h:mm")}`;
        }

        return null;
    },
    GetErrorMessage() {
        return (<MajorMessage>
            <div className="cs-Section__error-message">
                <h3>Saving failed for some reason.</h3>
                <h4>
                    First thing to do is
                    <button className="btn btn-primary cs-Section__message__button"
                            onClick={this.ClearErrors}>
                        Click here and try it again.
                    </button>
                </h4>
                <h4>
                    If it still isn't working, please contact Support Services.
                </h4>
            </div>
            <MajorError Error={this.props.Section.SaveError} />
        </MajorMessage>);
    },
    GetQuestionChangeHandler(q) {
        if (this.props.Section.Questions[0].AnswerSelections.length > 0
            && (this.props.Section.Questions[0].AnswerSelections[0].SelectionText == 'No' || this.props.Section.Questions[0].AnswerSelections[0].SelectionText == 'N/A')
            && this.props.Section.Questions[0].DisplayHTML.includes('If not, the remaining questions in this section will be skipped')
            && this.props.Section.Questions[0].GUID != q.GUID
        ) {
            q.ValidationStatus.IsValid = true;
            q.ValidationStatus.Message = [];
        }
        return (value) => {
            QuestionChangeDispatchers.QuestionChanged(q.GUID, value);
        };
    },
    ClearErrors() {
        const pageID = this.props.PageIDPath[
            this.props.PageIDPath.length - 1];

        SectionDispatchers.ClearError(
            pageID,
            this.props.Section.GUID);
    },
    Save() {
        SectionDispatchers.Save(this.props.PageIDPath, this.props.Section);
    },
    ToNextSection() {
        SectionDispatchers.LeaveSection(
            this.props.PageIDPath,
            this.props.Section,
            this.props.QuestionSnapshot,
            this.props.NextSectionID);
    },
    ToPreviousSection() {
        SectionDispatchers.LeaveSection(
            this.props.PageIDPath,
            this.props.Section,
            this.props.QuestionSnapshot,
            this.props.PreviousSectionID);
    },
    CompleteAudit() {
        SectionDispatchers.LeaveSection(
            this.props.PageIDPath,
            this.props.Section,
            this.props.QuestionSnapshot,
            config.ConfirmationPage);
    },
    HasUnvalidatedQuestions() {
        const anyUnvalidated = this.props.Section.Questions.some(q => {
            return !q.ValidationStatus;
        });

        return anyUnvalidated;
    },
    HasNoInvalids() {
        if (this.props.Section.Questions[0].DisplayHTML.includes('If not, the remaining questions in this section will be skipped')
            && this.props.Section.Questions[0].AnswerSelections[0].SelectionText == 'No') {
            return true;
        }

        const noInvalids = this.props.Section.Questions.every(q => {
            // No validation status means "unvalidated" which is good enough
            return !q.ValidationStatus || q.ValidationStatus.IsValid;
        });
        return noInvalids;
    },
    CheckWindowClose(e) {
        if (this.HasChanges()) {
            var confirmationMessage = "Are you sure you want to leave?  Unsaved changes will be lost.";

            e.returnValue = confirmationMessage;

            return confirmationMessage;
        }
    },
    HasChanges() {
        const differ = QuestionsDiffer(
            this.props.Section,
            this.props.QuestionSnapshot);

        return differ;
    }
});

module.exports = Section;


// WEBPACK FOOTER //
// ./src/components/Section/Section.jsx